import { useOutletContext, useParams } from "react-router-dom";
import AttendanceChat from "../../../components/AttendanceChat";
import { Row, Col } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import TraineeSubMenu from "../../../components/Submenu/TraineeSubMenu";
import printRules from "../../../components/PrintRules/style.module.scss";

export default function TraineesAttendanceChat() {
  const { trainee } = useOutletContext() || {};
  const { attendanceId } = useParams();

  return (
    <Main>
      <Content noBG="true">
        <Row>
          <Col sm={9} className={printRules.width_100_print}>
            <SubContent>
              <AttendanceChat id={attendanceId} />
            </SubContent>
          </Col>
          <Col sm={3} className={printRules.hide_on_print}>
            <TraineeSubMenu trainee={trainee} />
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
